import { Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SchoolIcon from '@mui/icons-material/School';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import { useNavigate } from 'react-router-dom';

const tiles = [
  {
    label: 'Репетитори',
    description: 'Управління репетиторами та їх доступом',
    icon: <SchoolIcon fontSize="large" color="primary" />,
    path: '/admin/tutors',
  },
  {
    label: 'Батьки',
    description: 'Батьківські акаунти та доступ до журналів',
    icon: <FamilyRestroomIcon fontSize="large" color="primary" />,
    path: '/admin/parents',
  },
  {
    label: 'Учні',
    description: 'Призначення репетиторів і батьків',
    icon: <PeopleAltIcon fontSize="large" color="primary" />,
    path: '/admin/students',
  },
];

const AdminHome = () => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={3}>
      {tiles.map((tile) => (
        <Grid item xs={12} md={4} key={tile.path}>
          <Card>
            <CardActionArea onClick={() => navigate(tile.path)}>
              <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {tile.icon}
                <Typography variant="h6">{tile.label}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {tile.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AdminHome;



